import type { Drag, Level, LevelRecord, Noria, Phase } from "./types";
import { LEVELS } from "./levels";

/** Mutable, session-global game state, kept in one object so feature modules
 *  can share it without a tangle of cross-module setters. */
export const state = {
  /** The current level definition. */
  level(): Level { return LEVELS[this.idx]; },
  cols(): number { return LEVELS[this.idx].cols; },
  rows(): number { return LEVELS[this.idx].rows; },
  phase: "intro" as Phase,
  /** Current level index. */
  idx: 0,
  /** Current grid cell size in px (recomputed responsively on resize). */
  cell: 48,
  /** Palm cells of the current level, as "r-c" keys. */
  treeSet: new Set<string>(),
  /** Boulder cells of the current level, as "r-c" keys. */
  rockSet: new Set<string>(),
  /** Norias currently placed on the board. */
  norias: [] as Noria[],
  /** Palms currently watered, as "r-c" keys (for bloom diffing). */
  aliveSet: new Set<string>(),
  /** Monotonic id source for norias. */
  nextId: 1,
  /** The in-progress pointer interaction, or null. */
  drag: null as Drag | null,
  /** Whether each level has been solved to 3 stars (the proven optimum). */
  completed: LEVELS.map(() => false),
  /** Persisted noria placements per level, so navigating back restores work. */
  saved: LEVELS.map(() => [] as [number, number][]),
  /** Frozen best attempt per level, fed to the reveal. */
  records: LEVELS.map((): LevelRecord => ({ norias: [], watered: 0 })),
};
